/*
 * angular-todo-prototype
 *
 * deviceprofile.component.ts
 *
 * Copyright (c) 2021 ForgeRock. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */

import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CallbackType, DeviceProfileCallback, FRDevice, FRStep } from '@forgerock/javascript-sdk';
import { from } from 'rxjs';
import { map, take } from 'rxjs/operators';

/**
 * Used to display a series of choices and allow the user to select one
 */
@Component({
  selector: 'app-deviceprofile',
  templateUrl: './deviceprofile.component.html',
})
export class DeviceProfileComponent implements OnChanges {
  ngOnChanges(changes: SimpleChanges): void {
    // console.log("in ngOnChanges...");
    if(changes['metadata'] || changes['step']) {
      this.handleCallback();
    }
    // console.log("emitting next step");
  }
  /**
   * The callback to be represented as select input
   */
  @Input() step: FRStep | undefined;
  /**
   * The name of the callback
   */
  @Input() name?: string;

  /**
   * Emits a string representing the value of the selected choice
   */
  @Output() next = new EventEmitter<FRStep>();

  /**
   * Emit an event to the parent component, passing the selected choice
   * @param event - the choice selected
   */
  handleCallback() {
    //  console.log("start handleCallback...");
    var callback=this.step?.getCallbackOfType(CallbackType.DeviceProfileCallback) as DeviceProfileCallback;
     if(callback){ 
        const device = new FRDevice();
        const location = callback?.isLocationRequired();
        const metadata = callback?.isMetadataRequired();
        const profile = from(device.getProfile({ location, metadata }));
        profile
              .pipe(
                take(1),
                map((p) => {
                  callback?.setProfile(p);
                  //console.log(p);
                  //console.log("emitting next step inside handleCallback");
                  this.next.emit(this.step);
                })
              )
            .subscribe();
    }
    //console.log("end handleCallback...");
  }
}
